function MenuController(){
	this.className			= "MenuController";
	this.glob				= "/**";
	this.priority			= 999;
	this.globUseHash		= true;
};
MenuController.inheritsFrom( StandardController );
MenuController.prototype.on = function(){

	if(!this.isSetup) this.setup();

};
MenuController.prototype.setup = function(state){

	if(this.isSetup) return false;

	this.$body 				= $("body");
	this.$page 				= this.$body.find('.js-page');
	this.$header 			= this.$body.find(".js-page-header");
	this.$menuButton 		= this.$header.find(".js-page-menu-button");
	this.$menu 				= this.$header.find(".js-page-menu");
	this.$mainMenu 			= this.$header.find(".js-main-menu");
	this.$menuItems			= this.$header.find(".js-main-menu a");
	this.$menuFooter		= this.$header.find(".js-menu-footer")

	var state = nav.getState();

	// Detect CSS prefix for browser
	this.transitionEvent 	= this.whichTransitionEvent();

	// Toggle menu
	this.$menuButton.off().on('click touchstart', (e) => {
		if(e.cancelable) e.preventDefault(); //touchstart can't call preventDefault
		this.toggleMenu();
	}).on('touchend', (e) => {
		e.preventDefault(); //Call prevent default to stop the click
	});

	// Close
	this.$close = this.$menu.find('.js-menu-background');
	this.$close.on("click touchstart", (e) => {
		if(e.cancelable) e.preventDefault();
		this.toggleMenu(false);
	});

	// Trigger on Keypress
	this.$body.on("keydown",this.keydownDelegate);
	this.keydownDelegate = (e) => {
		// Keypress: Escape
		if(e.which === 27) {
			e.preventDefault();
			e.stopPropagation();
			this.toggleMenu(false);
		}
	};

	//Do the menu links manually so that we can close the menu if it's the current page (eg. no nav change).
	this.$menuItems.on("click touchstart", e => {
		e.preventDefault();
		e.stopPropagation();
		const href = e.currentTarget.getAttribute("href");
		const hasChanged = nav.change(href);
		this.toggleMenu(false);
	});

	//preloads
	this.$menuItems.each(function(){
		jcache.getCache($(this).attr("href"));
	})

	jstage.addListener("resize",e => {
		this.checkContactDetails();
	})

	this.checkContactDetails();

	this.isSetup = true;
}
MenuController.prototype.toggleMenu = function(state){
	const isOpen = state ? state : this.$body.hasClass('menu-open');
	this.$body.toggleClass('menu-open', !isOpen);

	// Prevent clicks on specific links
	this.$body.find('.js-prevent-click')
		.off("click touchstart")
		.on("click touchstart", e => {
			e.preventDefault();
			e.stopPropagation();
			return false;
		}).css("cursor","default");

	this.checkContactDetails();
}
MenuController.prototype.checkContactDetails = function() {
	const menuOffset 	= this.$mainMenu[0].getBoundingClientRect();
	const contactOffset = this.$menuFooter[0].getBoundingClientRect();
	const padding		= contactOffset.height / 3; //roughly right, padding's harder to calculate because it's buried

	const show = contactOffset.top > menuOffset.bottom - padding;
	this.$menuFooter.css("visibility",show ? "visible" : "hidden")
}
MenuController.prototype.whichTransitionEvent = function() {
	var t, el = document.createElement("temp");

	var transitions = {
		"transition"      : "transitionend",
		"OTransition"     : "oTransitionEnd",
		"MozTransition"   : "transitionend",
		"WebkitTransition": "webkitTransitionEnd"
	}

	for (t in transitions){
		if (el.style[t] !== undefined){
			return transitions[t];
		}
	}
}
MenuController.prototype.destroy = function() {

}